export default "/images/vendor/flag-icon-css/flags/1x1/cc.svg?27d55bfa0a8b66542f74f3fc7049997c";